const PaymentMethod = {
  cb: 'CB',
  pp: 'PP',
  pa: 'PA',
  cr: 'CR',
  qe: 'QE',
  applePay: 'APPLE_PAY',
  oney: 'ONEY',
};

export default PaymentMethod;
